import { PointerSensor } from '@dnd-kit/core';
import type { PointerEvent } from 'react';

// The whole card is the drag activator, so presses that belong to a control
// inside it — the actions menu, the selection checkbox, quick view — must not
// turn into a drag.
const CARD_CONTROL_SELECTOR =
    'button, a, input, textarea, select, [role="menuitem"], [role="checkbox"]';

function startsOnCardControl(target: EventTarget | null): boolean {
    return (
        target instanceof Element &&
        target.closest(CARD_CONTROL_SELECTOR) !== null
    );
}

export class ReportEventPointerSensor extends PointerSensor {
    static activators = [
        {
            eventName: 'onPointerDown' as const,
            handler: ({ nativeEvent }: PointerEvent): boolean => {
                if (!nativeEvent.isPrimary || nativeEvent.button !== 0) {
                    return false;
                }
                return !startsOnCardControl(nativeEvent.target);
            },
        },
    ];
}
